import React from 'react';
import PropTypes from 'prop-types';
import { IconText } from 'components/core/IconText';
import { PhoneNumberButton } from 'components/contact/PhoneNumber';
import PhoneCircle from 'components/svg/PhoneCircle';

import './PhoneCallout.scss';

export function PhoneCallout({ text, formattedPhone, unformattedPhone }) {
	return (
		<div className="phone-callout">
			<IconText
				icon={PhoneCircle}
				size="medium"
			>
				{text}
			</IconText>
			<PhoneNumberButton
				dark
				phoneNumber={formattedPhone}
				unformattedPhoneNumber={unformattedPhone}
			/>
		</div>
	);
}

PhoneCallout.propTypes = {
	text: PropTypes.node.isRequired,
	formattedPhone: PropTypes.string.isRequired,
	unformattedPhone: PropTypes.string.isRequired
};

export default PhoneCallout;
